import { featuresItems } from '@/mocks/homeMangaData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            为什么选择咻咻漫画？三大核心优势告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-3xl mx-auto">
          {featuresItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-6 md:p-7 text-center border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}